import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getSale } from '../api';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { getApiErrorMessage } from '../utils/apiError';
import { ArrowLeft } from 'lucide-react';

export default function SaleDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sale, setSale] = useState(null);

  useEffect(() => {
    const fetchSale = async () => {
      try {
        const response = await getSale(id);
        setSale(response.data?.data || response.data);
      } catch (error) {
        toast.error(getApiErrorMessage(error, 'Error al cargar detalle'));
      }
    };
    fetchSale();
  }, [id]);

  if (!sale) {
    return <div className="p-6 md:p-10">Cargando...</div>;
  }

  return (
    <div className="p-6 md:p-10 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-[#2B2D42] font-['Manrope']">Detalle de venta</h1>
          <p className="text-[#5D5C61] mt-1">{sale.folio}</p>
        </div>
        <Button variant="outline" onClick={() => navigate('/ventas')}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver
        </Button>
      </div>

      <Card className="bg-white border-slate-100">
        <CardHeader>
          <CardTitle>Resumen</CardTitle>
        </CardHeader>
        <CardContent className="space-y-1 text-sm">
          <p><strong>Fecha:</strong> {new Date(sale.sale_date).toLocaleString('es-MX')}</p>
          <p><strong>Cliente:</strong> {sale.patient?.full_name || 'Sin cliente'}</p>
          <p><strong>Cita:</strong> {sale.appointment_id ? `#${sale.appointment_id}` : 'Sin cita asociada'}</p>
          <p><strong>Metodo de pago:</strong> {sale.payment_method || 'N/D'}</p>
          <p><strong>Estado:</strong> {sale.status}</p>
          <p><strong>Total:</strong> ${Number(sale.total || 0).toFixed(2)}</p>
        </CardContent>
      </Card>

      <Card className="bg-white border-slate-100">
        <CardHeader>
          <CardTitle>Productos vendidos</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {sale.items?.map((item) => (
            <div key={item.id} className="flex items-center justify-between border rounded-lg px-3 py-2">
              <div>
                <p className="font-medium">{item.product?.name || `Producto #${item.product_id}`}</p>
                <p className="text-xs text-[#8D99AE]">Cantidad: {item.quantity} · Precio: ${Number(item.unit_price).toFixed(2)}</p>
              </div>
              <p className="font-semibold">${Number(item.subtotal).toFixed(2)}</p>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}

